module.exports = __webpack_public_path__ + "static/media/dashboard_add_collaborator.f7895027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/dashboard_add_collaborator.jpg
// module id = 271
// module chunks = 0